import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactComponent as PDDFSymbol } from '../../assets/PDFSymbol.svg';
import { useTypedTheme } from '@monorepo-web/styles';
import { Link, useLocation } from 'react-router-dom';
import { LineSmall } from '../Line';
import { Container, BotaoPDFContainer, BotaoPDFText } from './style';
import { Skeleton } from '@mui/material';
export default function BotaoGerarPDF({ isAllLoaded }) {
    const { search, pathname } = useLocation();
    const theme = useTypedTheme();
    return (_jsx(Container, { children: _jsxs(BotaoPDFContainer, { children: [isAllLoaded ? (_jsxs(Link, Object.assign({ style: {
                        textDecoration: 'none',
                        color: 'inherit',
                        alignItems: 'center',
                        display: 'flex',
                        gridGap: '5px',
                    }, to: { pathname: '/pdf', search }, state: pathname }, { children: [_jsx(PDDFSymbol, { width: 22, height: 22, fill: theme.iconsColor }), _jsx(BotaoPDFText, { children: "Gerar PDF" })] }))) : (_jsx(Skeleton, { width: 60, style: { cursor: 'wait' } })), _jsx(LineSmall, {})] }) }));
}
